import { spotlightCases } from '@/mocks/homeData';

export default function Spotlight() {
  return (
    <section id="spotlight" className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-camera-lens-line"></i>现场直击
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold text-foreground-950 md:text-[28px]">名场面 · 图文并茂吃个透</h2>
          </div>
          <a href="#live" className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap">
            看更多现场 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {spotlightCases.map((c) => (
            <a key={c.id} href="#live" className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300">
              <div className="relative overflow-hidden">
                <img src={c.imgsrc} alt={c.title} title={`${c.title} 现场图`} className="aspect-[3/2] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur-sm">
                  <i className="ri-camera-lens-line"></i>{c.zone}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-foreground-800">
                  <i className="ri-fire-fill text-primary-500"></i>{c.reads}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-secondary-500">
                  <i className="ri-calendar-line"></i>{c.date}
                  <span>·</span>
                  <span>现场图文</span>
                </div>
                <h3 className="mt-2 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">{c.title}</h3>
                <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600 md:text-[13px]">{c.brief}</p>
                <span className="mt-auto inline-flex items-center gap-1 pt-3 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  展开还原现场 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}